import React, { useState, useRef, useEffect } from "react"
import "./styles.scss"

const Accordion = ({ handleActive, heightRecalc, ...props }) => {
  const content = useRef(null)
  const [active, setActive] = useState("")
  const [rotate, setRotateIcon] = useState("accordion__icon");
  const [height, setHeight] = useState("0px")
  const [overflow, setOverFlow] = useState(false)

  function toggleAccordion(props) {
    if(!props.isDisabled) {
      setActive(active === "" ? "active" : "");
      setHeight(
        active === "active" ? "0px" : `${content.current.scrollHeight}px`
      );
      setRotateIcon(
        active === "active" ? "accordion__icon" : "accordion__icon rotate"
      );
    }

    typeof handleActive === "function" && handleActive({...props, active, content});
  }

  useEffect(() => {
    if(heightRecalc && active){
      setHeight(`${content.current.scrollHeight}px`);
      setOverFlow(true)
    }
    else {
      setOverFlow(false)
    }
  }, [heightRecalc, active])

  return (
    <div id={props?.id} className={`accordion__section ${overflow && "overflow"}`}>
      <div className={`accordion ${active}`}>
        {props.header ? props.header : <span className="accordion__title">
          {props.title}
        </span>}
        <i className={`fi fi-rr-angle-small-right icon-down ${rotate}`} onClick={() => toggleAccordion(props)} />
      </div>
      <div ref={content} style={{ maxHeight: `${props?.maxHeight || height}`}} className={`accordion__content ${active} `}>
        {props.content ? <div className="accordion__text" dangerouslySetInnerHTML={{ __html: props.content }} /> : <div className="accordion__text">{props.children}</div>}
      </div>
    </div>
  )
}

export default Accordion

export const EmptyStateMessage = ({ message, iconClass = "fi fi-rr-inbox" }) => {
  return (
    <div className="empty-state-message">
      <i className={`empty-state-icon ${iconClass}`} />
      <p className="empty-state-text">{message}</p>
    </div>
  );
};
